import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    isLoggedIn: false,
    profile: {},
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    profile: state => state.profile,
  },
  mutations: {
    login(state, payload) {
      state.isLoggedIn = true;
      state.profile = payload;
      router.push('/manage');
    },
    logout(state) {
      state.isLoggedIn = false;
      state.profile = null;
      router.push('/login');
    },
  },
  actions: {},
});
